import(/* webpackMode: "eager", webpackExports: ["ClientAnalyticsTracker"] */ "/app/app/components/analytics/ClientAnalyticsTracker.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnreadMessagesNotifier"] */ "/app/app/components/auth/UnreadMessagesNotifier.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/HeaderInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderText"] */ "/app/app/components/HeaderText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarClient"] */ "/app/app/components/navbar/NavbarClient.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\",\"cyrillic\"],\"weight\":[\"400\",\"600\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
